module.exports = __webpack_public_path__ + "img/logo.e5a2ac1a.png";